import React from 'react';
import {toast} from 'react-toastify';
import api from '../irelandApi';
import ToastMessage from '../components/common/toast-message';

export const sendMessage = payLoad => api.post('/api/team/team_contacts/create', {...payLoad})
  .then((response) => {
    toast.error(<ToastMessage iconStyle="success" message="Sent"/>);
    return Promise.resolve(response.data);
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during contacting us"/>);
    return Promise.reject(error);
  });

export const getContact = () => api.get('/api/team/team_contacts/new')
  .then(response => Promise.resolve(response.data)).catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during contacting us"/>);
    return Promise.reject(error);
  });



// WEBPACK FOOTER //
// ./src/actions/contact-us.js